import React from 'react';
import styled from '@emotion/styled';
import { inputBaseClasses } from '@mui/material/InputBase';
import { Input } from '../../atoms/input/input';
import MenuItem, { menuItemClasses, MenuItemProps } from '@mui/material/MenuItem';
import { svgIconClasses } from '@mui/material/SvgIcon';
import { colorsUnifications } from '../../../style/global-style';

interface StyledMenuItemProps extends MenuItemProps {
    isSelected: boolean;
}

interface StyledCountryButtonProps {
    isActive: boolean;
}

export const StyledCountryButton = styled.button<StyledCountryButtonProps>`
    cursor: pointer;
    border-width: 0 2px 0 0;
    border-style: solid;
    border-color: ${(props) => props.theme.colorsUnifications.whiteSmoke['100']};
    background: #fff;
    margin: 0;
    font-size: 20px;
    padding: 0 16px;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    display: flex;
    align-items: center;

    .${svgIconClasses.root} {
        margin-left: 6px;
        transform: ${(props) => (props.isActive ? 'rotate(0deg)' : 'rotate(180deg)')};
        color: ${(props) =>
            props.isActive ? colorsUnifications.azure[100] : colorsUnifications.gunmetal[100]};
    }
`;

export const StyledFlagIcon = styled.span`
    line-height: 16px;
    width: 20px;
    height: 14px;
`;

export const StyledMenuItem = styled(({ isSelected, ...rest }: StyledMenuItemProps) => (
    <MenuItem {...rest} />
))`
    &.${menuItemClasses.root} {
        display: flex;
        align-items: center;
        font-size: 14px;
        line-height: 22px;
        font-weight: 600;
        border-radius: 5px;
        padding-left: 10px;
        padding-right: 10px;
        margin-left: 12px;
        margin-right: 12px;
        margin-bottom: 6px;

        background-color: ${(props) => (props.isSelected ? colorsUnifications.azure[4] : '#fff')};

        color: ${(props) =>
            props.isSelected ? colorsUnifications.azure[100] : colorsUnifications.gunmetal[100]};
    }

    span:first-child {
        font-size: 26px;
        margin-right: 6px;
    }

    span:nth-child(2) {
        overflow: hidden;
        text-overflow: ellipsis;
    }

    span:last-child {
        margin-left: auto;
        color: ${(props) =>
            props.isSelected ? colorsUnifications.azure[100] : colorsUnifications.gunmetal[50]};
    }
`;

export const StyledMenuSearch = styled(MenuItem)`
    &.${menuItemClasses.root} {
        margin-bottom: 10px;
        background-color: #fff;

        &.${menuItemClasses.focusVisible}, &:hover,
        &:active,
        &:focus {
            background-color: #fff;
            outline-color: transparent;
        }
    }
`;

export const StyledPhoneCode = styled.span`
    display: flex;
    font-size: 16px;
    line-height: 18px;
    align-items: center;
    padding: 0 6px 0 12px;

    ${(props) => props.theme.media.smAndUp} {
        font-size: 14px;
        line-height: 15px;
    }
`;

export const StyledInput = styled(Input)`
    &.${inputBaseClasses.root}.${inputBaseClasses.adornedStart} {
        align-items: stretch;

        &.${inputBaseClasses.error} {
            ${StyledCountryButton} {
                border-color: ${(props) => props.theme.colors.error};
            }
        }

        &.${inputBaseClasses.focused} {
            ${StyledCountryButton} {
                border-color: ${(props) => props.theme.colorsUnifications.azure['100']};
            }

            &.${inputBaseClasses.error} {
                ${StyledCountryButton} {
                    border-color: ${(props) => props.theme.colors.error};
                }
            }
        }
    }
`;

export const StyledClearButton = styled.button`
    cursor: pointer;
    border: none;
    background: #fff;
    margin: 0;
    padding: 0 4px;
    display: flex;
    align-items: center;

    .${svgIconClasses.root} {
        color: ${colorsUnifications.azure['100']};

        path {
            fill-opacity: 1;
        }
    }
`;
